import emojis from '../data';
import Card from './card';

const Grid = (props) => {
    let search = "";
    if(props.search)
        search = props.search;
    console.log(search)
    let filteredEmojis = emojis.filter(emoji => emoji.emoji.includes(search) || emoji.name.toLowerCase().includes(search.toLowerCase()));

    return (
        <main id="main">
            {
                filteredEmojis.map(emoji => {
                    return <Card key={emoji.id} emoji={emoji} />
                })
            }
        </main>
    );
}

export default Grid;